// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3Ywpt","form":"styles_form__3iJAn"};